import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

/**
 * 商城独立窗内跳转：必须带 /ai-Application-center/mall 前缀（若当前已在中心前缀下），
 * 并保留 standalone query，才能命中与列表同一 Layout，侧栏不丢。
 */
export function resolveMallBasePath(currentPath: string): string {
  if (currentPath.startsWith('/ai-Application-center/')) {
    return '/ai-Application-center/mall'
  }
  return '/mall'
}

export function useMallStandaloneNav() {
  const route = useRoute()
  const router = useRouter()
  const mallBase = computed(() => resolveMallBasePath(route.path))

  /** subPath 如 /product/spu/detail/1 或 product/spu/add；extraQuery 合并进 query */
  function pushMall(subPath: string, extraQuery?: Record<string, string | number | undefined>) {
    const normalized = subPath.startsWith('/') ? subPath : `/${subPath}`
    const query: Record<string, any> = { ...route.query }
    if (extraQuery) {
      for (const [k, v] of Object.entries(extraQuery)) {
        if (v === undefined) delete query[k]
        else query[k] = v
      }
    }
    return router.push({
      path: `${mallBase.value}${normalized}`,
      query
    })
  }

  return { mallBase, pushMall }
}
